import React from 'react';
// import * as XLSX from "xlsx"
import * as XLSX from "xlsx-js-style";
import {
  CLR_CANCEL,
  CLR_ERROR,
  CLR_INFO,
  CLR_SUCCESS,
  CLR_WARNING,
  ELECTION_PARTY_PARAM_NAMES,
  MODULE_APPOINTMENTS,
  MODULE_AUDIT,
  OnlyTextRegexPattern,
  ROLE_ADMIN,
  ROLE_MANAGER,
  WORK_TYPE_AADHAR,
  WORK_TYPE_OTHER,
} from "./constants";
import { isEmpty, isNull, isString } from "lodash";
import { Box, Tooltip } from "@mui/material";
import { Tooltip as AntdTooltip } from "antd";

import dayjs from "dayjs";
import zIndex from "@mui/material/styles/zIndex";
import { getToken } from "./services";
// import * as XLSX from "xlsx"
// import * as ExcelJs from "exceljs"
// import * as FileSaver from 'file-saver';

export const LS_key_user = "user";
export const LS_key_firstName = "firstName";
export const LS_key_lastName = "lastName";
export const LS_key_mobileNumber = "mobileNumber";

export const getUserData = () => {
  try {
    if (localStorage.getItem(LS_key_user)) {
      return JSON.parse(localStorage.getItem(LS_key_user));
    }
    return {
      role: "",
      modules: "",
    };
  } catch (e) {
    return {
      role: "",
      modules: "",
    };
  }
};

export const ls_isAdminUser =
  getUserData().role &&
  getUserData().role.toLowerCase().indexOf("admin") !== -1;
export const ls_isManagerUser =
  getUserData().role &&
  getUserData().role.toLowerCase().indexOf("manager") !== -1;
export const ls_isDataEntryUser =
  getUserData().role && getUserData().role.toLowerCase().indexOf("data") !== -1;
export const ls_isSupporterUser = () =>
  getUserData().role &&
  getUserData().role.toLowerCase().indexOf("supporter") !== -1;

export let ls_allModules = getUserData().modules
  ? getUserData()
    .modules.split(",")
    .map((module) => module.trim())
  : [];

export const setAllLsModules = () => {
  ls_allModules = getUserData().modules && getUserData().modules.split(",");
};

export const setLocalData = (data, reset) => {
  if (reset) {
    localStorage.removeItem(LS_key_firstName);
    localStorage.removeItem(LS_key_lastName);
    localStorage.removeItem(LS_key_mobileNumber);
    return;
  }

  if (data.firstName) localStorage.setItem(LS_key_firstName, data.firstName);
  if (data.lastName) localStorage.setItem(LS_key_lastName, data.lastName);
  if (data.mobileNumber)
    localStorage.setItem(LS_key_mobileNumber, data.mobileNumber);
};

export const getLocalData = (data) => {
  let result = {};

  if (
    !localStorage.getItem(LS_key_firstName) ||
    !localStorage.getItem(LS_key_lastName)
    // || !localStorage.getItem(LS_key_mobileNumber)
  ) {
    return null;
  }

  if (localStorage.getItem(LS_key_firstName))
    result.firstName = localStorage.getItem(LS_key_firstName);
  if (localStorage.getItem(LS_key_lastName))
    result.lastName = localStorage.getItem(LS_key_lastName);
  // if(localStorage.getItem(LS_key_mobileNumber)) result.mobileNumber = localStorage.getItem(LS_key_mobileNumber)

  return result;
};

export const tableFiledMapping = {
  "Id Card No": "idCardNo",
  "List No": "listNo",
  "Voter Id": "voterId",
  "Full Name": "fullName",
  Age: "age",
  "Society Name": "societyName",
  "Room No": "roomNo",
  "Mobile No": "mobileNo",
  "Birth Date": "birthDate",
  Education: "education",
  "Building/Bunglow Name": "buildingBunglowName",
  "Room No.": "roomNo2",
  Wing: "wing",
  Floor: "floor",
  "Currently Staying At": "currentAddress",
  "Remaining Address": "remainingAddress",
  "Mobile No.": "mobileNo2",
  "Whatsapp No": "whatsAppNo",
  DOB: "dob2",
  "Email ID": "emailId",
  "Survey 2021": "survey2021",
  "Survey 2024": "survey2024",

  "Voter Registration": "voterRegistration",
  Category: "category",
  "Category Ref By": "categoryRefBy",
  "Ref Mob. No.": "catRefMobNo",
  "Family Members": "familyMember",
  "Home Visit": "homeVisit",
  "Supporter Name": "supporterName",

  "Work Done": "workDone",
  Programme: "programmes",
  "Office Visit Work Details": "officeVisits",
};

export const SaveToExcel = (dataPassed, year) => {
  let filename = `Report_${year}.xlsx`;
  let data = dataPassed;

  var ws = XLSX.utils.json_to_sheet(data);
  var wb = XLSX.utils.book_new();

  const headerRow = [
    "IdCardNo",
    "ListNo",
    "VoterId",
    "FullName",
    "Age",
    "SocietyName",
    "RoomNo",
    "MobileNo",
    "BirthDate",
    "Education",
    "Building/BunglowName",
    "RoomNo.",
    "Wing",
    "Floor",
    "RemainingAddress",
    "CurrentAddress",
    "MobileNo.",
    "WhatsappNo",
    "DOB",
    "EmailID",
    "Survey2021",
    "Survey2024",
    "VoterRegistration",
    "Category",
    "CategoryRefBy",
    "RefMob.No.",
    "FamilyMembers",
    "HomeVisit",
    "SupporterName",
    "WorkDone",
    "Programme",
    "OfficeVisitWorkDetails",
    "Year",
    "electionYear",
    "electionType",
  ];

  for (var i in ws) {
    if (headerRow.includes(ws[i].v)) {
      ws[i].s = {
        font: {
          color: { rgb: "000000" },
        },
        fill: {
          patternType: "solid",
          fgColor: { rgb: "ffcc00" },
          bgColor: { rgb: "ffcc00" },
        },
      };
    }
  }

  XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
  XLSX.writeFile(wb, filename);
};

export const SaveToExcelGeneric = (
  headerArray,
  dataPassed,
  sheetTitle,
  year
) => {
  let filename = `${sheetTitle}_${year}.xlsx`;
  let data = dataPassed;

  var ws = XLSX.utils.json_to_sheet(data);
  var wb = XLSX.utils.book_new();

  const headerRow = [...headerArray];

  for (var i in ws) {
    if (headerRow.includes(ws[i].v)) {
      ws[i].s = {
        font: {
          color: { rgb: "000000" },
        },
        fill: {
          patternType: "solid",
          fgColor: { rgb: "ffcc00" },
          bgColor: { rgb: "ffcc00" },
        },
      };
    }
  }

  XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
  XLSX.writeFile(wb, filename);
};

export const downloadExcelViaApi = async (endpoint, fileName, body = {}) => {
  try {
    const clientId = getUserData()?.clientId;

    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        Accept: "text/csv",             // ⬅ CSV stream
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
        clientId: clientId,
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      throw new Error(`Download failed: ${res.status}`);
    }

    const blob = await res.blob();     // CSV stream → Blob

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = fileName;             // e.g., "Report.csv"
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("CSV download error:", error);
  }
};

// const getWidth = (keyName) => {
// 	if (!keyName) return 20

// 	let length = keyName.length

// 	switch (keyName) {
// 		case 'IdCardNo':
// 		case 'MobileNo': return length + 5
// 		case 'FullName':
// 		case 'SocietyName':
// 		case 'FamilyMembers': return length + 25
// 		case 'DOB': return length + 15
// 		case 'WorkDone':
// 		case 'Programme':
// 		case 'FamilyMembers': return length + 15
// 		default: return length
// 	}
// }

// export const SaveToExcel = (dataPassed, year) => {

// 	let filename = `Report_${year}.xlsx`;
// 	let data = dataPassed.map(obj => {
// 		let newObj = { ...obj }
// 		delete newObj.Year
// 		return newObj
// 	})

// 	const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
// 	const fileExtension = '.xlsx';
// 	const workbook = new ExcelJs.Workbook();
// 	workbook.creator = 'User';
// 	workbook.lastModifiedBy = 'other';
// 	workbook.created = new Date();
// 	workbook.modified = new Date();
// 	workbook.lastPrinted = new Date();
// 	workbook.properties.date1904 = true;
// 	debugger
// 	const sheet = workbook.addWorksheet('reportData');

// 	/** Fixed Left col and top row */
// 	sheet.views = [
// 		{ state: 'frozen', xSplit: 1, ySplit: 1 }
// 	];

// 	sheet.columns = Object.keys(data[0]).map(keyName => {
// 		return {
// 			header: keyName,
// 			columnName: keyName,
// 			key: keyName,
// 			width: getWidth(keyName)
// 		}
// 	})

// 	sheet.getRow(0).eachCell({ includeEmpty: true }, function (cell) {
// 		cell.fill = {
// 			type: 'pattern',
// 			pattern: 'solid',
// 			fgColor: { argb: 'FFFF00' } // Change 'FFFF00' to your desired color code
// 		};
// 	});
// 	sheet.addRows(data)

// 	workbook.xlsx.writeBuffer().then(buffer => {
// 		const blob = new Blob([buffer], { type: fileType })
// 		FileSaver.saveAs(blob, filename + fileExtension)
// 	})

// }

const replaceColumnsWholeArray = {
  ...tableFiledMapping,
  Year: "year",
  HomeVisit: "homeVisit",
  // RefByName: "supporterName",
};

export const getYearDropdownTillNow = () => {
  try {
    let currYear = dayjs().year();

    let arr = [];
    let lastYear = currYear;

    while (lastYear > 2014) {
      arr.push(lastYear);
      lastYear--;
    }

    return arr.map((s) => s.toString());
  } catch (e) {
    return ["2024"];
  }
};

export const replaceColumns = Object.values(replaceColumnsWholeArray).map(
  (lhsVal, index) => {
    let displayName = Object.keys(replaceColumnsWholeArray)
    [index].split(" ")
      .map((str) => `${str.charAt(0).toUpperCase()}${str.substring(1)}`)
      .join("");

    if (lhsVal === "societyName") displayName = "SocietyName";
    if (lhsVal === "idCardNo") displayName = "IdCardNo";
    if (lhsVal === "voterId") displayName = "VoterId";
    if (lhsVal === "listNo") displayName = "ListNo";
    if (lhsVal === "societyName") displayName = "SocietyName";
    if (lhsVal === "idCardNo") displayName = "IdCardNo";
    if (lhsVal === "voterId") displayName = "VoterId";
    if (lhsVal === "listNo") displayName = "ListNo";

    return { [lhsVal]: displayName };
  }
);

export const initialStateRouteParams = {
  workStatus: "",
  startDate: "",
  endDate: "",
  startDateObj: null,
  endDateObj: null,
  appointmentWith: null,
};

export const formControlSelectSx = {
  '& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused[data-shrink="true"]': {
    color: "var(--bg-blue)",
  },
  "& .MuiInputBase-root": {
    marginBottom: "1px",
  },
  "& .MuiInputBase-root::after": {
    borderColor: "var(--bg-blue)",
  },
};

export const dropdownContainerSx = {
  sx: {
    ".MuiInputBase-root": {
      marginTop: "13px",
    },
    "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
      paddingBlock: "6px",
    },
  },
  selectSx: {
    marginTop: "13px",
  },
};

export const categoryDropdownSx = {
  ...dropdownContainerSx,
  sx: {
    ...dropdownContainerSx.sx,
    ".MuiInputBase-root": {
      marginTop: "0",
    },
    "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
      paddingBlock: "0",
      paddingBottom: "2px",
    },
    "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.MuiSelect-select":
    {
      height: "1rem",
    },
  },
};

export const categoryDropdownFilterSx = {
  ...dropdownContainerSx,
  sx: {
    ...dropdownContainerSx.sx,
    ".MuiInputBase-root": {
      marginTop: "0px",
      backgroundColor: "#fff",
      borderRadius: 0,
    },
    ".MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderWidth: 0,
    },
    "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input": {
      paddingBlock: "7px",
    },
    "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.MuiSelect-select":
    {
      height: "1rem",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: 0,
    },
  },
};

export const formInitialValues = {
  idCardNo: "",
  listNo: "",
  voterId: "",
  fullName: "",
  age: "",
  societyName: "",
  roomNo: "",
  mobileNo: "",
  birthDate: "",
  education: "",
  buildingBunglowName: "",
  roomNo2: "",
  wing: "",
  floor: "",
  remainingAddress: "",
  currentAddress: "",
  mobileNo2: "",
  whatsAppNo: "",
  dob2: "",
  emailId: "",
  survey2021: "",
  survey2024: "",
  programmes: "",
  workDone: "",
  officeVisits: "",
  voterRegistration: "",
  category: "",
  categoryRefBy: "",
  catRefMobNo: "",
  familyMember: "",
  homeVisit: "",
  supporterName: "",
  electionType: "",
  electionYear: "",
};

export const addNewFormInitialValues = {
  idCardNo: "RSC",
  listNo: "",
  voterId: "",
  fullName: "",
  buildingBunglowName: "",
  roomNo: "",
  wing: "",
  floor: "",
  remainingAddress: "",
  currentAddress: "",
  mobileNo: "",
  whatsAppNo: "",
  dob: "",
  category: "",
  categoryRefBy: "",
  catRefMobNo: "",
  supporterName: "",
  familyMember: "",
  homeVisit: "",
  // electionTypeYear: "",
};

export const userFormInitialValues = {
  userId: "",
  email: "",
  mobileNo: "",
  firstNm: "",
  lastNm: "",
  userName: "",
  role: "",
  status: "",
  password: "",
  clientId: getUserData()?.clientId ? getUserData().clientId : "1",
};

export const workDoneInitialValues = {
  workId: null,
  workType: "",
  detailsType: "",
  workMode: "",
  workStatus: "",
  assignTo: "",
};

export const visitorFormInitialValues = {
  name: "",
  mobileNumber: "",
  address: "",
};

export let workFiltersInitialValues = {
  startDate: "",
  endDate: "",
  fullName: "",
  mobileNo: "",
  workStatus: [],
  workMode: [],
  workType: "",
  detailsType: [],
};

export const auditFiltersInitialValues = {
  startDate: "",
  endDate: "",
  idCardNo: "",
  fullName: "",
  mobileNo: "",
  status: [],
};

export const electionPollInitialValues = {
  electionResultsId: "",
  year: "",
  electionType: "",
  boothNumber: "",
  bhartiyaJanataParty: "0",
  indianNationalCongress: "0",
  shivSena: "0",
  shivSenaUbt: "0",
  nationalistCongressParty: "0",
  nationalistCongressPartySharadchandraPawar: "0",
  others: "0",
  totalVotesCasted: "",
};

export const pollFiltersInitialValues = {
  electionType: "",
  boothNumber: [],
  year: "",
};

export const graphFiltersInitialValues = {
  electionType: "",
  year: "",
};

export const appointmentFiltersInitialValues = {
  startDate: "",
  endDate: "",
  mobileNumber: "",
  appointmentWith: [],
  appointmentStatus: [],
};

export const appointmentFormInitialValues = {
  appointmentId: "",
  name: "",
  mobileNumber: "",
  address: "",
  appointmentWith: "",
  appointmentPurpose: "",
  appointmentType: "",
  date: "",
  startTime: "",
  endTime: "",
  timeObj: "",
  appointmentStatus: "",
  cancellationReason: "",
  visitorDTOList: [],
  visitorCategory: "",
};

export const workTypeDropdownList = [
  WORK_TYPE_AADHAR,
  WORK_TYPE_OTHER,
  "IN OFFICE",
];

export const workDoneDropdownSx = {
  "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input":
  {
    paddingBlock: "5px",
  },
  "& .MuiInputBase-input.MuiOutlinedInput-input": {
    fontFamily: '"Quicksand", sans-serif',
    fontWeight: "600",
  },
  "& .MuiOutlinedInput-notchedOutline legend > span": {
    opacity: "1",
    position: "relative",
    top: "-50%",
  },
  "div.MuiPaper-root.MuiPopover-paper.MuiMenu-paper:has(ul)": {
    maxHeight: "100px",
  },
};

export const workDoneDropdownResponsiveSx = {
  "@media(max-width: 500px)": {
    "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input":
    {
      fontSize: "0.9rem",
      paddingBlock: "5px",
    },
  },
};

export const dialogSx = {
  "& .MuiTypography-root.MuiDialogTitle-root": {
    fontFamily: '"Quicksand", sans-serif',
    fontWeight: "600",
    zIndex: 111,
  },
  "& .MuiDialogActions-root": {
    zIndex: 1100,
  },
  "@media(max-width: 500px)": {
    input: {
      fontSize: "0.8rem",
    },
    "& .MuiPaper-root.MuiDialog-paper": {
      minWidth: "90vw",
    },
    "& .MuiInputBase-root": {
      fontSize: "0.8rem",
    },
    "& .MuiDialogTitle-root": {
      position: "sticky",
      top: 0,
      backgroundColor: "#fff",
      borderBottom: "1px solid lightgrey",
    },
    "& .MuiDialogActions-root": {
      position: "sticky",
      bottom: 0,
      backgroundColor: "#fff",
      borderTop: "1px solid lightgrey",
    },
  },
};

export const ddEndAdornmentSx = {
  "& .MuiInputAdornment-root": {
    position: "relative",
    right: "10px",
  },
  "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall.MuiInputBase-inputHiddenLabel.MuiInputBase-inputAdornedEnd":
  {
    paddingRight: "10px",
  },
};

export const detailsTypeDropdownList = ["NEW", "UPDATE"];

export const statusDropdownList = ["OPEN", "IN PROGRESS", "COMPLETED"];

export const modeDropdownList = ["OFFICE VISIT", "ON CALL"];

export const defaultSnackbarState = {
  open: false,
  severity: "info",
  message: "",
};

export const defaultDropdowns = {
  category: [],
  homeVisit: [],
  electionType: [],
  electionYear: [],
  role: [],
};

export const getElectionTypeOrYear = (electionTypeYear, typeOrYear) => {
  if (!electionTypeYear || !electionTypeYear) return "";

  const delimiter = electionTypeYear.indexOf("(");

  if (typeOrYear === "type") {
    return electionTypeYear.substring(0, delimiter);
  }

  if (typeOrYear === "year") {
    return electionTypeYear.substring(
      delimiter + 1,
      electionTypeYear.indexOf(")")
    );
  }

  return electionTypeYear;
};

export const tabletQuery = { query: "(max-width: 1024px)" };
export const mobileQuery = { query: "(max-width: 600px)" };

export const generateFullAddress = (item) => {
  try {
    let newAddress = "";

    if (item?.buildingBunglowName)
      newAddress += `Building/Bunglow: ${item?.buildingBunglowName}, `;
    if (item?.roomNo2) newAddress += `Room No. ${item?.roomNo2}, `;
    // if(item?.roomNo) newAddress += `Room No. ${item?.roomNo}, `
    if (item?.wing) newAddress += `Wing ${item?.wing}, `;
    if (item?.floor) newAddress += `Floor ${item?.floor}, `;
    if (item?.remainingAddress) newAddress += `${item?.remainingAddress}`;

    newAddress = newAddress
      .split(",")
      .map((item) => item.trim())
      .filter((item) => Boolean(item))
      .join(", ");

    /** Limit max chars */
    if (newAddress.length > 100)
      newAddress = `${newAddress.substring(0, 100)}...`;

    return newAddress;
  } catch (e) {
    return item?.remainingAddress ?? "";
  }
};

export const limiMaxChars = (str, chars) => {
  if (str.length > chars) str = `${str.substring(0, chars)}...`;
  return str;
};
export function staticDelay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

if (ls_isAdminUser) {
  workFiltersInitialValues = {
    startDate: "",
    endDate: "",
    fullName: "",
    mobileNo: "",
    workStatus: [],
    category: "",
    workMode: [],
    workType: "",
    detailsType: [],
  };
}

export const ORANGE_COLOR_CODE = "#EF9138";
// export const ls_allowed_admin_modules = ls_allModules.every(name => [MODULE_VOTER, MODULE_REPORTS, MODULE_NON_VOTER, MODULE_USERS].includes(name) )
// export const ls_allowed_manager_modules = ls_allModules.every(name => [MODULE_VOTER, MODULE_REPORTS, MODULE_NON_VOTER].includes(name) )
// export const ls_allowed_dataEntry_modules = ls_allModules.every(name => [MODULE_VOTER, MODULE_NON_VOTER].includes(name) )
// export const ls_allowed_supporter_modules = ls_allModules.every(name => [MODULE_SUPPORTER].includes(name) )

export const shallShowTab = (tabName) => {
  return ls_allModules.includes(tabName) || tabName === MODULE_AUDIT;
  // return ls_allModules.includes(tabName)
};

export const isMobileNumberValid = (mobNo) => {
  if (!/^[0-9]+$/.test(mobNo)) {
    return false;
  }

  if (mobNo.length > 10) {
    return false;
  }

  return true;
};

export const isNumberFieldValid = (num) => {
  if (!num) return true;

  if (!/^[0-9]+$/.test(num)) {
    return false;
  }

  return true;
};

export const handleMobileNumberChange = (e, callback) => {
  if (typeof callback !== "function") return;

  if (!e.target.value) {
    callback();
    return;
  }

  if (isMobileNumberValid(e.target.value)) {
    callback();
  }
};
export const handleTextualFieldChange = (e, callback) => {
  if (!e.target.value) callback();

  if (OnlyTextRegexPattern.test(e.target.value)) {
    callback();
  }
};

export const handleNumberFieldChange = (e, callback) => {
  if (!e.target.value) callback();

  if (isNumberFieldValid(e.target.value)) {
    callback();
  }
};

export const convertDateFormat = (dateString) => {
  var parts = dateString.split("-");
  var newDateString = parts[2] + "/" + parts[1] + "/" + parts[0];
  return newDateString;
};

export const convertNullToBlank = (val) => {
  if (isNull(val) || (isString(val) && val.toLowerCase() === "null")) {
    return "";
  }
  return val;
};

export const initialCountData = {
  voterCount: "-",
  workCompletedCount: "-",
  workPendingCount: "-",
  birthdayCount: "-",
};

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const tabOverrideSx = {
  "& .MuiTabs-root": {
    minHeight: "auto",
  },
  "& .MuiButtonBase-root.MuiTab-root": {
    minHeight: "10px",
    paddingBlock: "5px",
  },
};

export function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box className={`p-4`}>{children}</Box>}
    </div>
  );
}

export function CustomTabPanelCompact(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box className={`pt-4`}>{children}</Box>}
    </div>
  );
}

/**
 * Password must contain min 8 letter with at least a symbol, upper and lower case letters and a number
 */
export const validatePassword = (s) => {
  const password_regex =
    /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return password_regex.test(s);
};

export const getStaticValidationScheme = () => {
  let initialSequence = [
    {
      name: "8 characters",
      rule: /^.{8,}$/,
      fulfilled: false,
    },
    {
      name: "1 uppercase letter",
      rule: /^(?=.*?[A-Z]).{1,}$/,
      fulfilled: false,
    },
    {
      name: "1 lowercase letter",
      rule: /^(?=.*?[a-z]).{1,}$/,
      fulfilled: false,
    },
    {
      name: "1 number",
      rule: /.*[0-9].*/,
      fulfilled: false,
    },
    {
      name: "1 special character",
      rule: /^(?=.*?[#?!@$%^&*-]).{1,}$/,
      fulfilled: false,
    },
  ];

  return initialSequence;
};

export const ignoreFormattingFor = ["idCardNo"];

export const formatWithOneSpaceWithCamelCase = (str) => {
  return str
    .replace(/\s+/g, " ")
    .split(" ")
    .map((s) => `${s.charAt(0).toUpperCase()}${s.substring(1).toLowerCase()}`)
    .join(" ");
};

export const ID_CARD_REGEX = /^RSC[0-9]+$/;
export const ID_CARD_NO_PREFIX = "RSC";

export const COL_1_PRCNT = 40;

export const scrollToTopId = (id) => {
  if (!id) return;

  setTimeout(() => {
    const ele = document.getElementById(id);

    if (ele) {
      ele.scrollTo(0, 0);
    }
  });
};

export function debounce(cb, delay = 250) {
  let timeout;

  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cb(...args);
    }, delay);
  };
}

export const reportObjectKeys = [
  "idCardNo",
  "listNo",
  "voterId",
  "fullName",
  "age",
  "societyName",
  "roomNo",
  "mobileNo",
  "birthDate",
  "birthdayWishHomeVisit",
  "birthdayWishOnCall",
  "education",
  "buildingBunglowName",
  "roomNo2",
  "wing",
  "floor",
  "remainingAddress",
  "currentAddress",
  "mobileNo2",
  "whatsAppNo",
  "dob2",
  "programmes",
  "workDone",
  "officeVisits",
  "category",
  "categoryRefBy",
  "catRefMobNo",
  "familyMember",
  "homeVisit",
  "supporterName",
  "electionTypeYear",
];

export const reportObjectSelectableKeys = ["category"];

export const IMPORTED_COL_DATA_NAMES = [
  "idCardNo",
  "listNo",
  "voterId",
  "fullName",
  "age",
  "societyName",
  "roomNo",
  "mobileNo",
  "birthDate",
  "education",
];

export const isDataForImportedCol = (dataName) => {
  return IMPORTED_COL_DATA_NAMES.includes(dataName);
};

export const voterModalScrollId = "voter-id";
export const nonVoterModalScrollId = "non-voter-id";

export const dateRegex_DDMMYYYY_withSlash =
  /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/;
export const dateRegex_DDMMYYYY_withHyphen =
  /^(0[1-9]|[1-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/;
export const dateRegex_YYYYMMDD =
  /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/;
export const dateRegex_MMDDYY_withSlash =
  /^(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])\/\d{2}$/;
export const dateRegex_MDDYY =
  /^(1[0-2]|0?[1-9])\/(0?[1-9]|[1-2][0-9]|3[0-1])\/\d{2}$/;

const allDateRegex = [
  dateRegex_DDMMYYYY_withSlash,
  dateRegex_DDMMYYYY_withHyphen,
  dateRegex_YYYYMMDD,
  dateRegex_MMDDYY_withSlash,
  dateRegex_MDDYY,
];

export const excelImportDateFormat = "YYYY-MM-DD";

export function isValidDateFormatForExcel(input) {
  // Check if the input string matches the regex pattern
  return allDateRegex.some((regx) => regx.test(input));
}

export const replaceAll = (str, findChar, replaceChar) => {
  if (!str) return str;
  if (typeof str !== "string") return str;

  let newStr = "";
  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) === findChar) {
      newStr += replaceChar;
    } else {
      newStr += str.charAt(i);
    }
  }

  return newStr;
};

export const compareData = (data1, data2, operation) => {
  if (!data1 || !data1 || !operation) return false;

  if (operation === "equal") {
    return data1 === data2;
  }
  if (operation === "unequal") {
    return data1 !== data2;
  }
  return false;
};

export const getLabelValueMapping = (arr) => {
  if (arr.length === 0) return [];

  return arr.map((val) => ({ label: val, value: val }));
};

export const getCardClassName = (item) => {
  let str = `rounded-md border border-2 `;
  switch (item.color) {
    case "orange": {
      str += `border-orange-100 rounded-md bg-gradient-to-r from-zinc-50 to-orange-100`;
      break;
    }
    case "violet": {
      str += `border-violet-100 rounded-md bg-gradient-to-r from-zinc-50 to-violet-100`;
      break;
    }
    case "amber": {
      str += `border-amber-100 rounded-md bg-gradient-to-r from-zinc-50 to-amber-100`;
      break;
    }
    case "blue": {
      str += `border-blue-100 rounded-md bg-gradient-to-r from-zinc-50 to-blue-100`;
      break;
    }
    case "red": {
      str += `border-red-100 rounded-md bg-gradient-to-r from-zinc-50 to-red-100`;
      break;
    }
    case "green": {
      str += `border-green-100 rounded-md bg-gradient-to-r from-zinc-50 to-green-100`;
      break;
    }
    case "lime": {
      str += `border-lime-100 rounded-md bg-gradient-to-r from-zinc-50 to-lime-100`;
      break;
    }
    case "slate": {
      str += `border-slate-100 rounded-md bg-gradient-to-r from-zinc-50 to-slate-100`;
      break;
    }
    default: {
    }
  }

  return str;
};

export const getIconClassName = (color) => {
  let str = `text-4xl `;
  switch (color) {
    case "orange": {
      str += `text-orange-500`;
      break;
    }
    case "violet": {
      str += `text-violet-500`;
      break;
    }
    case "amber": {
      str += `text-amber-500`;
      break;
    }
    case "blue": {
      str += `text-blue-500`;
      break;
    }
    case "red": {
      str += `text-red-500`;
      break;
    }
    case "green": {
      str += `text-green-500`;
      break;
    }
    case "lime": {
      str += `text-lime-500`;
      break;
    }
    case "slate": {
      str += `text-slate-500`;
      break;
    }
    default: {
      // return `border rounded-md`
    }
  }

  return str;
};

export const ChipSx = {
  "& .MuiChip-root": {
    height: "22px",
    fontSize: "12px",
    "& .MuiChip-deleteIcon": {
      fontSize: "19px",
    },
  },
};

export const getChipColor = (color) => {
  if (!color) return "primary";
  if (["complete", "done"].some((str) => color.toLowerCase().includes(str)))
    return CLR_SUCCESS;
  if (["todo", "open"].some((str) => color.toLowerCase().includes(str)))
    return CLR_ERROR;
  if (["progress", "schedule"].some((str) => color.toLowerCase().includes(str)))
    return CLR_WARNING;
  if (["attend"].some((str) => color.toLowerCase().includes(str)))
    return CLR_INFO;
  return CLR_CANCEL;
};

export const getMaxVotesInRecord = (obj) => {
  let maxVotes = obj?.[ELECTION_PARTY_PARAM_NAMES[0]] ?? 0;

  ELECTION_PARTY_PARAM_NAMES.forEach((partyName, inx) => {
    let thisPartyVotes = Number(obj?.[partyName] ?? 0);

    if (maxVotes < thisPartyVotes) {
      maxVotes = thisPartyVotes;
    }
  });

  return maxVotes;
};

export const MandatoryIcon = ({ title }) => {
  return (
    <span className="cursor-pointer absolute top-[-8px] right-[-8px] z-10 height-[10px] text-[1.2rem] bg-white border-[1px_solid_red] text-red-600 ml-1">
      <Tooltip title={title}>*</Tooltip>
    </span>
  );
};

export const ModalTooltipAntd = (props) => {
  const fnProps = {
    ...props,
  };

  if (fnProps.children) delete fnProps.children;

  return (
    <AntdTooltip
      {...props}
      overlayStyle={{
        zIndex: 100000,
      }}
    >
      {props.children}
    </AntdTooltip>
  );
};

export const MobileNumberInLink = ({ mobNo }) => {
  return (
    <a
      title={`click to make a call on: ${mobNo}`}
      href={`tel:${mobNo}`}
      className="underline text-blue-500 text-left "
    >
      {mobNo}
    </a>
  );
};

export const EmailInLink = ({ mailId }) => {
  return (
    <a
      title={`click to send a mail to: ${mailId}`}
      href={`mailTo:${mailId}`}
      className="underline text-blue-500 text-left "
    >
      {mailId}
    </a>
  );
};

export const TwoMobileNumberInLink = ({ mobNos }) => {
  if (!mobNos || typeof mobNos !== "string") return null;

  const shortText = mobNos.length > 25 ? mobNos.slice(0, 22) + '…' : mobNos;

  return (
    <Tooltip title={mobNos} placement="top" arrow>
      <span className="inline-block truncate text-blue-600 hover:text-blue-800 cursor-pointer max-w-full">
        {shortText}
      </span>
    </Tooltip>
  );
};
// export const TwoMobileNumberInLink = ({ mobNos }) => {
//   return (
//     <>
//       {mobNos && typeof mobNos === "string" ? (
//         mobNos.split("/").length > 1 ? (
//           <div className="flex">
//             {mobNos.split("/").map((str, index) => {
//               return (
//                 <div className="flex" key={index}>
//                   <a
//                     href={`tel:${str}`}
//                     className="underline text-blue-500 text-left "
//                     title={`click to make a call on: ${str}`}
//                   >
//                     {str}
//                   </a>
//                   {index < mobNos.split("/").length - 1 ? "/" : ""}
//                 </div>
//               );
//             })}
//           </div>
//         ) : (
//           <>
//             <a
//               href={`tel:${mobNos}`}
//               className="underline text-blue-500 text-center"
//               title={`click to make a call on: ${mobNos}`}
//             >
//               {mobNos}
//             </a>
//           </>
//         )
//       ) : null}
//     </>
//   );
// };

export const styledTableRowDDSx = {
  "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input": {
    paddingLeft: "5px",
    paddingRight: "12px",
    fontSize: "0.85rem",
  },
};

export const styledTableRowAutocmpltSx = {
  "& .MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
    paddingBlock: "3px",
    position: "relative",
    top: "5px",
    fontSize: "0.9rem",
  },
};

export const topFiltersAutocompleteSx = {
  "& .MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
    paddingBlock: "6px",
    backgroundColor: "white",
    fontSize: "14px",
  },
};

export const responsiveAutocompleteSx = {
  "@media(max-width: 500px)": {
    "& .MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
      fontSize: "14px",
    },
  },
};

export const isAddEditAllowed = (workStatus) => {
  const statuses = ["complete", "attend"];
  return statuses.every((st) => !workStatus?.toLowerCase().includes(st));
};

export const canUploadExcel = () => {
  const userData = getUserData() ?? {};

  if (userData?.role === ROLE_ADMIN || userData?.role === ROLE_MANAGER)
    return true;
  return false;
};

export const voterStatusLOVList = ["Active", "Archived"];

export const isEmptyValue = (val) => {
  if (!val) return true;

  if (typeof val === "object" && Array.isArray(val) && val.length <= 0)
    return true;

  if (val instanceof Date)
    return !(val instanceof Date) || isNaN(val.getTime());

  if (isEmpty(val)) return true;

  return false;
};

export function hasAlphaOnly(str) {
  return /^[A-Za-z\s]+$/.test(str);
}

export const handleDebouncedCallback = async (timer, callback) => {
  timer?.current && clearTimeout(timer);
  // await awaitedProcess(500)
  timer = setTimeout(() => {
    callback();
  }, 3000);
};
